import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { PayloadType } from '~proto/payload/payload_pb';
import { ConstantsService } from '~services/constants.service';
import { trackById } from '~utilities/trackById';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ct-select-payload-type',
  styleUrls: ['./select-payload-type.component.scss'],
  templateUrl: './select-payload-type.component.html',
})
export class SelectPayloadTypeComponent implements OnInit {
  public trackById = trackById;
  @Input() public payloadName = 'this';
  @Input() public allowedPayloadTypes = [];
  @Output() public selectedPayload = new EventEmitter();
  public fc = new FormControl(null, { validators: Validators.required });
  public payloadTypes: PayloadType.AsObject[];
  constructor(
    private constants: ConstantsService,
    @Optional() private matDialogRef: MatDialogRef<SelectPayloadTypeComponent>,
  ) {}

  public ngOnInit() {
    this.payloadTypes = Object.values(this.constants.payloadTypes);
    if (this.allowedPayloadTypes.length > 0) {
      this.payloadTypes = this.payloadTypes.filter(type => this.allowedPayloadTypes.includes(type.id));
    }
    this.payloadTypes.sort((a, b) => a.name.localeCompare(b.name));
  }

  public selected() {
    if (this.fc.invalid) {
      return;
    }
    this.selectedPayload.emit(this.fc.value);
    if (this.matDialogRef) {
      this.matDialogRef.close(this.fc.value);
    }
  }
}
